import { render, staticRenderFns } from "./ManageSubmissionsSectorAssociationRepresentative.vue?vue&type=template&id=392d184a&"
import script from "./ManageSubmissionsSectorAssociationRepresentative.vue?vue&type=script&lang=js&"
export * from "./ManageSubmissionsSectorAssociationRepresentative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports